( function ( $ ) {


	function initializeAccordion( $block ) {
		$block.find('.accordion-button').click(function () {
			$(this).parent().parent().find('.accordion-collapse').slideToggle();
			$(this).toggleClass('collapsed');
		})
	}
	$(document).ready(function (e) {
		$('.indy-block-accordion').each(function () {
			initializeAccordion( $(this) )
		})
	})


	if( window.acf ) {
		window.acf.addAction( 'render_block_preview/type=indy/accordion', initializeAccordion );
	}
} )( jQuery );
